import { _ } from '@splunk/ui-utils/i18n';

export const ErrorMsgs = {
    NO_DATA_SOURCES: _('No valid dataSources.'),
    NO_ENCODING: _('No valid encoding.'),
    ERROR_PARSE: _('Can not parse data correctly.'),
};
